import {
  GetPartnerMeResponse,
  PostLoginRequest,
  PostLoginResponse,
} from '../../api/type/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  loginRequest: PostLoginRequest;
  loginResponse: PostLoginResponse;
  shouldCheckBusinessProfile: boolean; // 비즈니스 프로필 미입력 체크 > 로그인 성공 플래그
  shouldCheckServiceAdd: boolean;
  profileResponse: GetPartnerMeResponse | null;
}

const initialState: AuthState = {
  loginRequest: {
    loginId: '',
    password: '',
  },
  loginResponse: {
    accessToken: '',
    role: 'CENTER',
  },
  shouldCheckBusinessProfile: false,
  shouldCheckServiceAdd: false,
  profileResponse: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setInputLoginId: (state, action: PayloadAction<string>) => {
      state.loginRequest.loginId = action.payload;
    },
    setInputLoginPassword: (state, action: PayloadAction<string>) => {
      state.loginRequest.password = action.payload;
    },
    setLoginResponse: (state, action: PayloadAction<PostLoginResponse>) => {
      state.loginResponse = action.payload;
    },
    setShouldCheckBusinessProfile: (state, action: PayloadAction<boolean>) => {
      state.shouldCheckBusinessProfile = action.payload;
    },
    setShouldCheckServiceAdd: (state, action: PayloadAction<boolean>) => {
      state.shouldCheckServiceAdd = action.payload;
    },
    setProfileMe: (
      state,
      action: PayloadAction<Partial<GetPartnerMeResponse>>
    ) => {
      if (!state.profileResponse) {
        state.profileResponse = action.payload as GetPartnerMeResponse;
        return;
      }

      Object.assign(state.profileResponse, action.payload);
    },
  },
});

export const auth = authSlice.actions;
export default authSlice.reducer;
